module.exports = __webpack_public_path__ + "media/placeholder.a34abea2.mp4";